/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { myInternshipV4Schema } from './myInternshipV4Schema'
import { orgTypeNameSchema } from './orgTypeNameSchema'

export const myRoleV4Schema = z
  .object({
    orgId: z
      .string()
      .nullable()
      .default('')
      .describe(
        'Context org id (coded). NULL only for the Edy365 entry (its discriminator); the individual account carries the coded all-zeros id. For a STUDENT entry this is the EDU org id.'
      )
      .meta({ examples: ['kJ8v2Qm7xR1a'] }),
    roleType: orgTypeNameSchema.describe(
      'Context category: "Org" / "Edu" / "Intern" (student) / "Edy365".'
    ),
    name: z.string().min(1).default('').describe('Display name of the entry.'),
    isCurrent: z
      .boolean()
      .default(false)
      .describe('True for the entry matching the active token context.'),
    myInternships: z
      .array(myInternshipV4Schema)
      .nullable()
      .default([])
      .describe(
        'For "Intern" (student) entries: the user\'s internships in this EDU org (switch targets). Null for other entry types.'
      ),
  })
  .describe('One row of the me/roles context switcher list.')
